module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('mu-appbar', {
    staticClass: "header",
    attrs: {
      "title": "我的消息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.accesstoken) ? _c('div', {
    staticClass: "content"
  }, [(_vm.readMsg.hasnot_read_messages) ? _c('mu-list-item', {
    staticClass: "list-item",
    attrs: {
      "title": "未读消息",
      "toggleNested": "",
      "open": false
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "visibility_off"
    },
    slot: "left"
  }), _vm._v(" "), _vm._l((_vm.readMsg.hasnot_read_messages), function(item) {
    return _c('mu-list-item', {
      key: item.id,
      staticClass: "list-item-content",
      attrs: {
        "to": {
          path: '/vue-home/dist/content',
          query: {
            id: item.topic.id
          }
        },
        "title": item.title
      },
      slot: "nested"
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "msg-num"
  }, [_vm._v(_vm._s(_vm.readMsg.hasnot_read_messages.length))])], 2) : _vm._e(), _vm._v(" "), (_vm.readMsg.has_read_messages) ? _c('mu-list-item', {
    staticClass: "list-item",
    attrs: {
      "title": "已读消息",
      "toggleNested": "",
      "open": false
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "visibility"
    },
    slot: "left"
  }), _vm._v(" "), _vm._l((_vm.readMsg.has_read_messages), function(item) {
    return _c('mu-list-item', {
      key: item.id,
      staticClass: "list-item-content",
      attrs: {
        "to": {
          path: '/vue-home/dist/content',
          query: {
            id: item.topic.id
          }
        },
        "title": item.title
      },
      slot: "nested"
    }, [_c('span', [_vm._v("来自"), _c('strong', [_vm._v(_vm._s(item.author.loginname))])]), _vm._v(" "), _c('span', {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.reply.create_at)))]), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "message-content"
    }, [_vm._v(_vm._s(item.reply.content))]), _vm._v(" "), _c('span', {
      staticClass: "message-title"
    }, [_vm._v("帖子：《" + _vm._s(item.topic.title) + "》")]), _vm._v(" "), _c('span', {
      staticClass: "message-ups"
    }, [_vm._v("获" + _vm._s(item.reply.ups.length) + "个赞")])])
  }), _vm._v(" "), _c('span', {
    staticClass: "msg-num"
  }, [_vm._v(_vm._s(_vm.readMsg.has_read_messages.length))])], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.accesstoken) ? _c('div', {
    staticClass: "message-tip"
  }, [_c('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "to": "/vue-home/dist/login",
      "label": "请先登录",
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('FooterNav')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d9802d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/message.vue
// module id = 139
// module chunks = 1